import { Remediator } from './Base/Remediator';
export class SelectEnrollProfile extends Remediator {
    canRemediate() {
        return true;
    }
}
SelectEnrollProfile.remediationName = 'select-enroll-profile';
